import { gql } from "@apollo/client";
import { DocketTemplateTypeNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { DocketTemplateType as DocketTemplateTypeEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import DocketTemplateType from "../../data/model/DocketTemplateType";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { SyncProgressStatus } from "../page-query";

const docketTemplateTypesQuery = gql`
  ${DocketTemplateTypeNoNestingFragment}
  query GetDocketTemplateTypes($filters: DocketTemplateTypeListFilterOptions) {
    docketTemplateTypes(filters: $filters) {
      ...DocketTemplateTypeNoNesting
    }
  }
`;

export const docketTemplateTypeDefinition = new EntityResourceDefinition<
  DocketTemplateTypeEntity,
  DocketTemplateType
>({
  entity: "docket_template_types",
  query: docketTemplateTypesQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.html = fetchedEntity.html || "";
    newEntity.css = fetchedEntity.css;
  },
  fetchEntities: async (options) => {
    return client
      .query({
        query: docketTemplateTypesQuery,
        variables: {
          filters: {
            updatedAt: options?.after,
          },
        },
      })
      .then(async (res) => {
        const progressCallback = options?.progressCallback;

        await progressCallback?.({
          fetched: res.data.docketTemplateTypes.length,
          estimatedTotalItems: res.data.docketTemplateTypes.length,
          status: SyncProgressStatus.FETCHING,
          totalItems: res.data.docketTemplateTypes.length,
        });

        return res.data.docketTemplateTypes;
      });
  },
});
